export class ClientTxnReq {
  reference: string;
  startDate: string;
  endDate: string;
  pageIndex: number;
  pageSize: number;
  constructor(
    starDate?: string,
    endDate?: string,
    pageIndex?: number,
    pageSize?: number
  ) {
    this.reference = "";
    this.startDate = starDate;
    this.endDate = endDate;
    this.pageIndex = 0;
    this.pageSize = 10;
  }
}

export class ClientTxnRes {
  clientID: string;
  createdAt: string;
  direction: string;
  clientusers: clientusers;
  financialTransactionType: string;
  lastUpdated: string;
  narration: string;
  processed: string;
  processingReference: string;
  processingStatus: string;
  reservationId: string;
  settlementReference: string;
  transactionAmount: number;
  transactionCurrency: string;
  transactionReference: string;
  transactionStatus: string;
  transactionType: string;
}

export class clientusers {
  active: boolean;
  bankAccountCode: string;
  bankAccountCurrency: string;
  bankAccountNumber: string;
  clientEmail: string;
  email: string;
  fullname: string;
  phone: string;
}
